'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaderTitle = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _src = require('../../rules/src');

var _getFlagsAndNotes = require('./table/getFlagsAndNotes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getHeaderTitle = exports.getHeaderTitle = function getHeaderTitle(dataflow, attributes, display, customAttributes) {
  return {
    label: (0, _src.dimensionValueDisplay)(display)(dataflow),
    flags: R.pipe(_getFlagsAndNotes.getFlagsAndNotes, R.map(function (entry) {
      return {
        code: entry.code,
        header: (0, _src.dimensionValueDisplay)(display)(entry) + ':',
        label: (0, _src.dimensionValueDisplay)(display)(entry.value)
      };
    }))(attributes, customAttributes)
  };
};